<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
    <b-modal
      id="ch_login_modal"
      ref="modal"
      title="Login with Chenosis"
      :busy="loading"
    >
      <b-form class="form" @submit.prevent="passes(doSubmit)">
        <p class="text-danger" v-if="errors.phone">
          {{ errors.phone[0] }}
        </p>

        <validation-provider
          name="phone"
          rules="required|digits:10"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <input
              class="form-control"
              placeholder="Enter MTN Mobile Number"
              v-model="phone"
            />
          </div>

          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
      </b-form>

      <p>
        You will receive a prompt on your phone to approve for your data to be
        shared with Ownaradio. Reply with 1 to accept.
      </p>

      <p><strong>Note:</strong> Currently supported only on MTN Ghana</p>


      <template v-slot:modal-footer>
        <b-button
          variant="info"
          type="submit"
          @click="doSubmit"
          :disabled="invalid || loading || !onLine"
        >
          {{ loading ? "Loading.." : "Continue" }}
        </b-button>
      </template>
    </b-modal>
    <chenosis-login-process-modal ref="chenosisLoginProcessModal"></chenosis-login-process-modal>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import ChenosisLoginProcessModal from "./ChenosisLoginProcessModal.vue";
import ApiService from "@/plugins/ApiService";

export default {
  name: "ChenosisLoginlModal",

  components: {
    ValidationObserver,
    ValidationProvider,
    ChenosisLoginProcessModal,
  },

  data() {
    return {
      phone: "",
      transaction_id: null,
      formattedPhone: "",
      type: "",
      loading:false
    };
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      onLine: (state) => state.auth.onLine,
    }),

  },

  mounted() {
    const phone = this.getAyoba()?.getMsisdn();
    this.phone = phone ? "0" + phone.substring(4) : null;

  },


  methods: {
    create(type) {
      this.type = type
      this.$refs.modal.show();
    },

    formatPhone() {
      const cleanedPhone = this.phone.replace(/^0+/, ""); // Remove leading zeros
      this.formattedPhone = `233${cleanedPhone}`;
    },

    async continue() {
      this.formatPhone();

      // console.log(this.formattedPhone);

      try {
        this.loading = true
        const response = await ApiService.send(
          "chenosis/" + this.formattedPhone,
          "get"
        );

        this.loading = false


        console.log(response.data);


        return response.data;
      } catch (error) {
        this.loading = false

        console.error(error);
        throw error;
      }
    },

    async doSubmit() {
      try {
        const responseData = await this.continue();

        this.$refs.modal.hide();
        this.$refs.chenosisLoginProcessModal.create(
          responseData.transactionId,
          this.formattedPhone,
          this.type
        );
      } catch (error) {
        console.error(error);
        this.$refs.observer.setErrors(this.errors);
      }
    },
  },
};
</script>



